class MainSearch extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    this.input = this.querySelector('.main-search__input');
    this.box = this.querySelector('.main-search__results');
    if (!this.input || !this.box) return;

    this.timeout = null;
    this.lastValue = '';

    /* ===== INPUT ===== */
    this.input.addEventListener('input', () => {
      const q = this.input.value.trim();

      if (!q) {
        this.close();
        this.box.innerHTML = '';
        this.lastValue = '';
        return;
      }

      this.open();

      if (q === this.lastValue) return;
      this.lastValue = q;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.search(q), 300);
    });

    /* ===== FOCUS ===== */
    this.input.addEventListener('focus', () => {
      if (this.input.value.trim()) {
        this.open();
      }
    });

    /* ===== BLUR ===== */
    this.input.addEventListener('blur', () => {
      // даємо можливість клікнути по результатах
      setTimeout(() => this.close(), 150);
    });

    /* ===== ESC ===== */
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.input.blur();
        this.close();
      }
    });
  }

  /* =====================
     STATE
  ===================== */
  open() {
    this.classList.add('is-open');
  }

  close() {
    this.classList.remove('is-open');
  }

  /* =====================
     STATIC SUGGESTIONS
  ===================== */
  getStaticSuggestions() {
    return [
      this.getAttribute('data-suggestion-1'),
      this.getAttribute('data-suggestion-2'),
      this.getAttribute('data-suggestion-3'),
      this.getAttribute('data-suggestion-4'),
    ].filter(Boolean);
  }

  formatPrice(price) {
    const num = Number(price);
    if (Number.isNaN(num)) {
      return String(price ?? '');
    }
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  /* =====================
     SEARCH
  ===================== */
  async search(q) {
    const box = this.box;

    // Show loading indicator
    box.innerHTML = `
      <div class="search-suggestions-loading">
        <div class="loading-spinner"></div>
        <span>Loading...</span>
      </div>
    `;

    const url = new URL('/search/suggest.json', location.origin);
    url.searchParams.set('q', q);
    url.searchParams.set('resources[type]', 'product,query');
    url.searchParams.set('resources[limit]', '10');

    let data = { resources: { results: { queries: [], products: [] } } };

    try {
      const res = await fetch(url);
      if (res.ok) data = await res.json();
    } catch (e) {
      console.warn('Predictive search error', e);
    }

    // Update with results
    box.innerHTML = `
      <div class="search-suggestions">
        <h6 class="search-suggestions__mainText">Search Suggestions</h6>
        <ul class="search-suggestions__list"></ul>
      </div>

      <div class="product-suggestions">
        <h6>Product Suggestions</h6>
        <ul></ul>
      </div>

      <a class="search-all-link">See more results for "${q}"</a>
    `;

    /* ===== TEXT SUGGESTIONS ===== */
    const list = box.querySelector('.search-suggestions ul');
    const final = [];

    // Shopify queries (max 3)
    data.resources.results.queries.forEach(item => {
      if (final.length < 3) {
        final.push({ text: item.text, url: item.url });
      }
    });

    // Static (Theme editor)
    this.getStaticSuggestions().forEach(text => {
      if (final.length >= 5) return;
      if (final.some(i => i.text.toLowerCase() === text.toLowerCase())) return;

      final.push({
        text,
        url: `/search?q=${encodeURIComponent(text)}`
      });
    });

    final.forEach(item => {
      list.insertAdjacentHTML(
        'beforeend',
        `<li class="search-suggestions-list__point">
          <a href="${item.url}">${item.text}</a>
        </li>`
      );
    });

    if (!final.length) {
      box.querySelector('.search-suggestions')?.remove();
    }

 /* ===== PRODUCTS ===== */
const pList = box.querySelector('.product-suggestions ul');

// Перевіряємо, чи ми в хедері. Якщо ні (наприклад, на сторінці), ставимо ліміт 2, інакше 3.
const isHeader = this.closest('header') !== null;
const productLimit = isHeader ? 2 : 3;

data.resources.results.products.slice(0, productLimit).forEach(p => {
  const priceHtml = this.formatPrice(p.price);
  pList.insertAdjacentHTML(
    'beforeend',
    `
    <li class="product-suggestion">
      <a href="${p.url}">
        ${p.image ? `<img src="${p.image}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy">` : ''}
        <div class="Product-container">
          <div class="title-Product">${p.title}</div>
          <div class="price"><span class="price-currency">$</span><span class="price-amount">${priceHtml}</span><span class="price-note">(Setting Only)</span></div>
        </div>
      </a>
    </li>
    `
  );
});
    box.querySelector('.search-all-link').href =
      `/search?q=${encodeURIComponent(q)}`;
  }
}

customElements.define('main-search', MainSearch);
